import api from '@/api';
import { readCookie } from '@/utils/cookie';

let hasAttemptedAttribution = false;

/**
 * Trigger Tolt affiliate attribution for existing logged-in users.
 *
 * When a logged-in user visits via an affiliate link (?ref=partner_id),
 * tolt.js captures the referral in a cookie. This function triggers the backend API
 * to create a Tolt customer with the team ID, ensuring payment tracking works.
 *
 * The backend reads the tolt_data cookie directly (shared via .animaapp.com domain).
 */
export const triggerToltAttribution = async (teamId) => {
  // Only run once per session
  if (hasAttemptedAttribution) {
    return;
  }

  // Check if there's a tolt_data cookie (set by tolt.js with partner info)
  const toltCookie = readCookie('tolt_data');
  const hasToltCookie = toltCookie !== undefined && toltCookie !== null && toltCookie !== '';

  if (!teamId || !hasToltCookie) {
    return;
  }

  hasAttemptedAttribution = true;

  try {
    // Trigger backend API - it reads the cookie directly via credentials: 'include'
    await api.post(`/api/teams/${teamId}/tolt`, {}, { withCredentials: true });
  } catch (error) {
    // Silently fail - affiliate tracking is non-critical
    console.debug('[Tolt] Attribution failed:', error);
  }
};
